module.exports = __webpack_public_path__ + "img/csm_Ersa-Selective-VERSAFLEX-01-900x675_95c62de2d5.ee2b96e1.jpg";